module.exports = __webpack_public_path__ + "img/evolution3.8df5010b.png";